import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Events } from 'src/api';
import { SaveBtn, Input } from 'src/components/Common';
import { toast } from 'react-toastify';
import './AddHackathon.scss';

import { Mixpanel } from '../../Mixpanel';

class AddHackathonModal extends Component {
  constructor() {
    super();
    this.state = {
      name: '',
      link: '',
      tags: '',
      nameErrors: '',
      linkErrors: '',
      tagsErrors: '',
      sendingRequest: false,
    };
  }

  componentDidMount() {
    Mixpanel.track('Open add hackathon');
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      [e.target.name + 'Errors']: [],
    })
  }

  getRecommendEventForm = () => {
    return {
      name: this.state.name,
      link: this.state.link,
      tags: this.state.tags,
    }
  }
  
  submitHackathon = (e) => {
    Mixpanel.track('Send hackathon');
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      sendingRequest: true,
    });
    const submitForm = this.getRecommendEventForm();
    Events.recommendEvent(submitForm)
      .then(() => {
        this.setState({
          sendingRequest: false,
        });
        toast.success('Спасибо за ссылку! Aдмины RH проверят её и опубликуют.');
        this.props.closeModal();
      })
      .catch((e) => {
        const resData = e.response.data;
        const errors = {};
        if (resData['user']) {
          toast.error('Чтобы добавить хакатон нужно быть авторизованным');
        }
        Object.keys(resData).forEach((err) => {
          errors[err + 'Errors'] = resData[err];
        })
        this.setState({
          sendingRequest: false,
          ...errors,
        });
      });
  }

  render() {
    return (
      <div className="modal add-hackathon">
        <div>
          <h1>Добавить хакатон</h1>
          <Input className="modal--input-block modal--input-block__column"
            labelText="Название хакатона"
            name="name"
            placeholder="Название хакатона"
            value={this.state.name}
            onChange={this.handleInputChange}
            errors={this.state.nameErrors}
          />
          <Input className="modal--input-block modal--input-block__column"
            labelText="Сайт мероприятия"
            name="link"
            placeholder="Сайт мероприятия"
            value={this.state.link}
            onChange={this.handleInputChange}
            errors={this.state.linkErrors}
          />
        {/*
          <Input className="modal--input-block modal--input-block__column"
            labelText="Тэги"
            name="tags"
            placeholder="Список тэгов"
            value={this.state.tags}
            onChange={this.handleInputChange}
            errors={this.state.tagsErrors}
          />
        */}
          <SaveBtn saveText="Добавить" cancelText="Отменить"
            onSave={this.submitHackathon} onCancel={this.props.closeModal}
            disabled={this.state.sendingRequest} />
        </div>
      </div>
    );
  }
}

AddHackathonModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
}

export default AddHackathonModal;



// WEBPACK FOOTER //
// ./src/components/Modal/AddHackathon/index.js